export const DEFAULT_MANDATE_REFERENCE_PATTERN = "MU-{LN12}-{ID8}";

function normalizeForMandate(value: unknown, max: number): string {
  return String(value || "")
    .trim()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, "")
    .slice(0, max);
}

function sanitizeMandateReference(value: string): string {
  return value
    .toUpperCase()
    .replace(/[^A-Z0-9\-:_.]+/g, "")
    .replace(/-{2,}/g, "-")
    .replace(/^[-:_.]+|[-:_.]+$/g, "")
    .slice(0, 35);
}

export function generateMandateReference(args: {
  pattern?: string | null;
  personId?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  dateText: string;
  studioCode?: string | null;
}): string {
  const id8 = (String(args.personId || "").replace(/-/g, "").toUpperCase() + "00000000").slice(0, 8);
  const ln12 = normalizeForMandate(args.lastName, 12);
  const fn12 = normalizeForMandate(args.firstName, 12);
  const studio = String(args.studioCode || "").trim();

  const pattern = String(args.pattern || "").trim() || DEFAULT_MANDATE_REFERENCE_PATTERN;
  const refRaw = pattern
    .replace(/\{ID8\}/gi, id8)
    .replace(/\{DATE\}/gi, args.dateText)
    .replace(/\{LN12\}/gi, ln12)
    .replace(/\{FN12\}/gi, fn12)
    .replace(/\{STUDIO\}/gi, studio);

  return sanitizeMandateReference(refRaw);
}
